<nz-layout>
  <nz-content
    ><ng-container>
      <app-reusable-table
        title="Past Medication"
        [columns]="[
          'Period',
          'Product',
          'Package',
          'Unit',
          'Frequency',
          'Duration',
          'Scheduled Days',
        ]"
        [rowFields]="[
          'periodCombination',
          'productCombination',
          'packageCombination',
          'unitCombination',
          'frequencyCombination',
          'durationTreatmentCombination',
          'scheduledDaysCombination',
        ]"
        [data]="pastMedication"
        [isLoading]="isLoading"
        [deleteFun]="deleteFun"
        [openModalFun]="openModalFun"
        [revertStopFun]="revertStopFun"
        [expandComponent]="expandComp"
        [isPreview]="false"
        [isStopped]="true"
        [addPermissions]="['a-pmed']"
        [stopPermissions]="['s-med']"
      />
    </ng-container>
  </nz-content>
</nz-layout>
